import React, {useContext, useEffect, useState} from "react";
import LOGO from "../img/LOGO.png";
import lg from "../img/lg.png"

import {Helmet} from "react-helmet";

import { createClient } from '@supabase/supabase-js'

import Select from 'react-select'
import Async, { useAsync } from 'react-select/async';
import AsyncSelect from "react-select/async";

const supabase = createClient('https://sxipkzxjsnnaybxthrxf.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN4aXBrenhqc25uYXlieHRocnhmIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzY3NDEwMzgsImV4cCI6MTk5MjMxNzAzOH0.ToB8TL555TnCAjl_jmNdhY86bmTvttL5K1aRAlZUOI8')
const AddYearPage = () => {

    const [ value, setValue ] = useState()
    const [ options, setOptions ] = useState([])

    const [ points, setPoints ] = useState([])
    const [ count, setCount ] = useState('')
    // const options = [
    //     { value: 'chocolate', label: 'Chocolate' },
    //     { value: 'strawberry', label: 'Strawberry' },
    //     { value: 'vanilla', label: 'Vanilla' }
    // ]

    //
    async function fetchData () {
        const { data, error } = await supabase
            .from('cities')
            .select('value, label, geo_lat, geo_lon, count')
            .gt('count', 0)
            .order('label')
        return data
    }

    useEffect (() => {
        fetchData(value).then((data)=>{
            setPoints(data)
            // console.log(data)
        })
    },[])

    const onIChange = (newValue) => {
        async function fetchData (value) {
            const { data, error } = await supabase
                .from('cities')
                .select('value, label, geo_lat, geo_lon, count')
                .like('label', '%'+newValue+'%')
            return data
        }
        if (value !== ''){
            fetchData(value).then((data)=>{
                setOptions(data)
                // console.log(data)
            })
        }
    }

    const onSChange = (choice) => {
        setValue(choice)
        setCount('')
    }

    const updateItem = async () => {
        if (count !== ''){
            const { error } = await supabase
                .from('cities')
                .update({ count:  count})
                .eq('value', value.value)

            fetchData(value).then((data)=>{
                setPoints(data)
                // console.log(data)
            })
            alert('ok')
        }


    }



    // const loadOptions = (inputValue, callback) => {
    //     setTimeout(() => {
    //         callback(options);
    //     }, 1000);
    // };





    return (
        <div className='bg-gray-50'>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Хроника протестов в России - Присоединиться</title>
                <meta name="description" content="Список антивоенных движений в России"/>

                {/*Facebook Meta Tags*/}
                <meta property="og:url" content="https://remap-ru.com/join"/>
                <meta property="og:type" content="website"/>
                <meta property="og:title" content="Хроника протестов в России - Присоединиться"/>
                <meta property="og:description" content="Список антивоенных движений в России"/>
                <meta property="og:image" content={LOGO}/>

            </Helmet>

            <main className=''>
                <div className='py-20'>
                    <div className='flex max-w-7xl mx-auto items-center px-3'>
                        <div className='w-auto'>
                            <img src={lg} width={80} alt=""/>
                        </div>
                        <div className='pl-6'>
                            <h2 className='text-2xl font-bold text-neutral-900'>24.02.2023</h2>
                            <h1 className='text-4xl font-bold text-neutral-800 pt-1'>РОССИЯ СКОРБИТ</h1>
                            <h1 className='text-2xl font-bold text-neutral-900 pt-1'>День памяти и скорби*</h1>
                        </div>
                    </div>
                    {/*<img src={low} alt=""/>*/}
                </div>
                <div className='max-w-7xl mx-auto px-4'>
                    <div className='max-w-md flex flex-col py-4'>
                        <div>Город:</div>
                        <Select onChange={(choice) => onSChange(choice)} onInputChange={(newValue=>{onIChange(newValue)})} options={options} />

                        <div className='pt-4'>Количество:</div>
                        <input value={count} onChange={(e)=> setCount(e.target.value)} type="number" placeholder={value?.count} className='w-full border border-neutral-300 rounded p-2 outline-blue-500'/>

                        <div className='flex'>
                            <div onClick={() => updateItem()} className='mt-6 bg-blue-400 px-4 py-2 rounded cursor-pointer hover:bg-blue-400'>
                                Сохранить
                            </div>
                        </div>

                    </div>

                </div>

                <div className='max-w-7xl mx-auto px-4 py-12'>
                    <div>
                        {points.map((point)=>
                            <>
                                {point.label},&nbsp;
                            </>
                        )}
                    </div>
                    <div className='border '>
                    </div>

                    <div className="flex flex-col">
                        <div className="-m-1.5 overflow-x-auto">
                            <div className="p-1.5 min-w-full inline-block align-middle">
                                <div className="overflow-hidden">
                                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                                        <thead>
                                        <tr>
                                            <th scope="col"
                                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Город
                                            </th>
                                            <th scope="col"
                                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">К-во мемориалов
                                            </th>
                                            <th scope="col"
                                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Широта
                                            </th>
                                            <th scope="col"
                                                className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Долгота
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                                        {points.map((point)=>
                                            <tr>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200">
                                                    {point.label}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200 font-medium">
                                                    {point.count}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200">
                                                    {point.geo_lat}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm ">
                                                    {point.geo_lon}
                                                </td>
                                            </tr>
                                        )}



                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </main>
        </div>
    )
}

export default AddYearPage